import { HandlerBuilder } from '../middleware/handler-builder.js';

function getComposedMiddleWares(controllerMiddlewares, actionPointMetaData) {
    const middlewares = []
        .concat(controllerMiddlewares.useBefore)
        .concat(controllerMiddlewares.use)
        .concat(actionPointMetaData.beforeMiddlewares)
        .concat(actionPointMetaData.middlewares)
        .concat([actionPointMetaData])
        .concat(actionPointMetaData.afterMiddlewares)
        .concat(controllerMiddlewares.useAfter)
        .filter(item => !!item)
        .map(middleware => HandlerBuilder.from(middleware).build());
    return middlewares;
}

export { getComposedMiddleWares };
//# sourceMappingURL=compose-middlewares.js.map
